import { useState } from "react";
import Login from "./Login";
import ChatApp from "./ChatApp";
import SetPassword from "./SetPassword";

function App() {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user") || "null")
  );

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
  };

  if (user?.needsPassword) {
    return (
      <SetPassword
        email={user.email}
        onDone={() => setUser(null)}
      />
    );
  }

  if (!user) {
    return <Login onLogin={setUser} />;
  }

  return <ChatApp user={user} onLogout={handleLogout} />;
}

export default App;